var VARIABLE_SEARCH_REGEX = new RegExp('\\${?(?<key>[a-zA-Z0-9$_]+)}?', 'g');
export var uppercaseFirstLetter = function (str) {
    return str && typeof str === 'string' && "".concat(str.substring(0, 1).toUpperCase()).concat(str.substring(1));
};
export var compareStringNoCaseSensitive = function (textA, textB) {
    return textA.toLowerCase() === textB.toLowerCase();
};
export var findStringNoCaseSensitive = function (textArray, textToFind) {
    return textArray.some(function (text) { return text.toLowerCase() === textToFind.toLowerCase(); });
};
export var convertToNumber = function (text) {
    if (!text) {
        console.error("Invalid value can't parse in to number", text);
        return 0;
    }
    var result = Number.parseInt(text, 10);
    if (Number.isNaN(result)) {
        console.error("Invalid value can't parse in to number", text);
        return 0;
    }
    return result;
};
export var convertSnakeCaseToCamelCase = function (text) {
    return text.toLowerCase().replace(/([_][a-z])/g, function (group) { return group.toUpperCase().replace('-', '').replace('_', ''); });
};
export var replaceVariablesInString = function (string, variables) {
    if (!variables) {
        return string;
    }
    return string.replace(VARIABLE_SEARCH_REGEX, function (match, varName, offset, fullString) {
        if (Object.keys(variables).includes(varName)) {
            return variables[varName];
        }
        console.log("The '".concat(varName, "' variable does not exist in provided variables (won't be replaced)"), variables);
        return match;
    });
};
/**
 * Generates a UUID in case of randomUUID is not available (only available ih https context)
 * See : https://developer.mozilla.org/fr/docs/Web/API/Crypto/randomUUID
 * @returns a string representing an unique UUID
 */
export var generateUUID = function () {
    var uuid = (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID)
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0;
            var v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    return uuid;
};
